export default "__VITE_ASSET__OM3Z8Mg7__"